export { ManagementCapabilities as default } from '@signageos/common-types/dist/Device/Capabilities/ManagementCapabilities';
